import React from "react";
import ModalBody from "./modalbody"
import Nav from './headerlinks';


const MenuModal = () => (
    <ModalBody>
        <div className="menumodal flex-start flex-column">
            <Nav />
        </div>
    </ModalBody>
) 

export default MenuModal